import toastr from 'toastr'
import { funcModal } from 'components/modals'
import { dateFormat, currencySymbol } from 'filters'
import pagination from 'components/pagination'
import { hasPermits } from 'directives'
import { editableText, editableRadio } from 'components/editable'
import { permits } from 'services'
import tabs from 'components/tabs/tabs'
import tab from 'components/tabs/tab'
import esim from './esim/esim.vue'
import parkguard from './parkguard/parkguard.vue'
import lounge from './lounge/lounge.vue'

const directives = {
  hasPermits
}

const components = {
  funcModal,
  pagination,
  editableText,
  editableRadio,
  tabs,
  tab,
  esim,
  parkguard,
  lounge
}

const filters = {
  dateFormat,
  currencySymbol,
  capitalize: (value) => {
    if (!value) return value;
    return value.charAt(0).toUpperCase() + value.slice(1);
  }
}

const computed = {
  isSuperAdmin () {
    return permits.hasPermit('super_admin');
  },

  isChannelUser () {
    return !permits.hasPermit('super_admin') && permits.hasPermit('channel_user');
  },

  hasAncillaries () {
    return this.accessibleAncillaries && this.accessibleAncillaries.length > 0;
  },

  accessibleAncillaries () {
    if (!Array.isArray(this.form.ancillaries)) {
      return [];
    }
    let accessible = [];
  
    if (this.isSuperAdmin) {
      accessible = this.form.ancillaries;
    } else {
      accessible = this.form.ancillaries.filter(ancillary => ancillary.access == 1);
    }

    if (!this.localActiveTab) {
      this.localActiveTab = {
        title: accessible[0].ancillary_type.charAt(0).toUpperCase() + accessible[0].ancillary_type.slice(1)
      };
    }

    return accessible;
  },

  esim_reservations () {
    return _.cloneDeep(this.$store.state.channels.active.esim_reservations);
  },

  parkguard_reservations () {
    return _.cloneDeep(this.$store.state.channels.active.parkguard_reservations);
  },

  lounge_reservations () {
    return _.cloneDeep(this.$store.state.channels.active.lounge_reservations);
  },

  ancillaries () {
    return _.cloneDeep(this.form.ancillaries);
  },

  need_to_save () {
    return this.$store.state.channels.active.need_to_save;
  },

  errors () {
    if (this.$store.state.channels.errors) {
      return this.$store.state.channels.errors.errors;
    }

    return {}
  },

  error () {
    return this.$store.state.channels.errors;
  }
}

const methods = {
  handleTabChange (tab) {
    this.localActiveTab = tab;
  },

  getComponentName (ancillaryType) {
    const componentMap = {
      'esim': 'esim',
      'parkguard': 'parkguard',
      'lounge': 'lounge'
    };
    
    return componentMap[ancillaryType];
  },

  getAncillaryName (ancillary) {
    if (ancillary.ancillary_type === 'parkguard') {
      return ancillary.display_name;
    } else if (ancillary.ancillary_type === 'esim') {
      return 'eSIM';
    }
    return ancillary.ancillary_type;
  },

  getAncillaryIndex (ancillary) {
    return this.formData.ancillaries.findIndex(item => 
      item.ancillary_type === ancillary.ancillary_type
    );
  },

  loadPage (page, action = 'channels.getAncillaries') { 
    this.loading = true;
    return this.$store.dispatch(action, {
      channel_id: this.$route.params.id,
      params: {
        page,
        _sort: '-id',
        testing: this.testingMode ? 1 : 0,
      }
    }).then(() => {
      this.loading = false;
    });
  },

  markupValueChanged (event, index) {
    let errors = {};
    this.$emit('throwErrors', errors);
    if (isNaN(event.value)) {
      let key = `channels.${index}.markup_value`;
      errors[key] = [];
      errors[key].push("Markup Value can only be a number")
      this.$emit('throwErrors', errors);
      return;
    }

    event.startLoading();
    let value = Number(event.value);
    this.formData.ancillaries[index]['markup_value'] = value;
    // this.channels[index]['coupon_limit'] = value;
    

    event.stopLoading();
    event.close();
  },

  additionalFieldChanged (event, key, index) {
    const newValue = event.value.replace(/\s+/g, '');

    if (key =='network_brand') {
      if (newValue !== '') {
        const isValid = /^[A-Za-z0-9]{1,15}$/.test(newValue);
        if (!isValid) {
          let errors = {};
          let error_key = `channels.${index}.additional_fields.${key}`;
          errors[error_key] = [];
          errors[error_key].push("Network brand can only contain letters and numbers (max 15 characters)");
          toastr.error("Network brand can only contain letters and numbers (max 15 characters)");
          this.$emit('throwErrors', errors);
          return;
        }
      }
    }
    event.startLoading();
  
    this.formData.ancillaries[index]['additional_fields'][key]['value'] = newValue === '' ? null : newValue;
  
    event.stopLoading();
    event.close();
  },

  formatKey(key) {
    const withSpaces = key.replace(/_/g, ' ');
    return withSpaces.charAt(0).toUpperCase() + withSpaces.slice(1);
  },

  reslabFeeValueChanged (event, index) {
    let errors = {};
    this.$emit('throwErrors', errors);
    if (isNaN(event.value)) {
      let key = `channels.${index}.reslab_fee_value`;
      errors[key] = [];
      errors[key].push("Reslab Fee can only be a number")
      this.$emit('throwErrors', errors);
      return;
    }

    event.startLoading();
    let value = Number(event.value);
    this.formData.ancillaries[index]['reslab_fee_value'] = value;
    // this.channels[index]['coupon_limit'] = value;
    

    event.stopLoading();
    event.close();
  }

}

const watch = {
  activeTab (n) {
    if (n.title == "Ancillaries") {
      this.loading = true;
      Promise.all([
        this.loadPage(1),
      ]).then(() => {
        this.loading = false;
      });
    }
  },

  testingMode (n) {
    if (this.activeTab.title === 'Ancillaries') {
      // this.loadEsimReservations(1)
    }
  },

  formData (n, o) {
    if (n == o) return;

    this.form = n;
  }
}

export default {
  name: 'ancillaries-tab',
  props: ['formData', 'activeTab', 'testingMode'],
  components,
  computed,
  filters,
  methods,
  directives,
  watch,
  data () {
    return {
      // errors: {},
      saving: false,
      form: this.formData,
      webhooks: [],
      showLogs: false,
      loading: false,
      showEsimReservations: {},
      localActiveTab: null
    }
  },

  created() {
    this.loadPage(1);
  }
}
